import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const AuthSurfaceRoot = styled(Paper)({
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  border: 'none',
  borderRadius: 0,
  boxShadow: 'none',
  maxWidth: 520,
  padding: 0,
  width: '100%',
});
